import React from 'react';
import { useHistory } from 'react-router-dom';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Button from './Button';

const BackButton = () => {
  const history = useHistory();

  function navigateBack() {
    history.goBack();
  }

  return (
    <Button
      label="form.backButtonLabel"
      startIcon={<ArrowBackIcon />}
      position="left"
      color="default"
      onClick={navigateBack}
    />
  );
};

export default BackButton;
